const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://2fizk3p7b0.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://4yad2l9251.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.3',
    HOSTNAME: 'https://locations.dev.dlpocclient.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.dlpocclient.forwoodsafety.com',
    WEBSOCKET: 'wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;